import React from 'react';
import { StickyAlertBar } from '../components/StickyAlertBar';
import { HeroSection } from '../components/HeroSection';
import { SalesLetter } from '../components/SalesLetter';
import { WhatYouGet } from '../components/WhatYouGet';
import { BonusSection } from '../components/BonusSection';
import { WhatsAppTestimonials } from '../components/WhatsAppTestimonials';
import { PricingOffer } from '../components/PricingOffer';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  return <div style={{
    background: '#F6F1E7',
    minHeight: '100vh'
  }} data-id="element-325">
      <StickyAlertBar data-id="element-326" />
      <HeroSection data-id="element-327" />
      <SalesLetter data-id="element-328" />
      <WhatYouGet data-id="element-329" />
      <BonusSection data-id="element-330" />
      <WhatsAppTestimonials data-id="element-331" />
      <PricingOffer data-id="element-332" />
      <Testimonials data-id="element-333" />
      <FAQ data-id="element-334" />
      <FooterSection data-id="element-335" />
    </div>;
}